// Pord. — Terms & Policy
// Full content reproduced from the document the user provided (image upload).

export default function Terms() {
  return (
    <main
      data-testid="terms-page"
      className="max-w-[820px] mx-auto px-8 pt-16 pb-8"
    >
      <section className="fade-in mb-16">
        <div className="eyebrow mb-6">Legal · Last updated 05·29·2026</div>
        <h1
          className="headline"
          style={{
            fontSize: "clamp(36px, 5vw, 60px)",
            marginBottom: 22,
          }}
        >
          Terms & <span style={{ color: "var(--pord-teal)" }}>Policy</span>
        </h1>
        <p
          style={{
            color: "var(--pord-muted)",
            fontSize: 17,
            lineHeight: 1.75,
            maxWidth: 680,
          }}
          data-testid="terms-lead"
        >
          You agree to the terms of service below.
        </p>
      </section>

      {/* PART 1 - DISCLAIMER */}
      <Part
        index="Part 1"
        title="Disclaimer"
        testid="part-disclaimer"
        sections={[
          {
            heading: "1.1 Not Investment Advice",
            body: (
              <>
                Passed Performance. and all creative works (namely under Pord.
                and Clarity Soundtrack) created this publication are for
                educational purposes. Nothing on this site — including
                simulations, copy, modules, visuals, and any current or future
                feature — constitutes investment advice, financial advice, tax
                advice, legal advice, or a recommendation to buy, sell, hold,
                or otherwise transact in any security, fund, asset class, or
                financial instrument. Passed Performance does not guarantee
                future results.
              </>
            ),
          },
          {
            heading: "1.2 No Fiduciary or Advisory Relationship",
            body: (
              <>
                <p style={{ marginBottom: 16 }}>
                  Using this website, and submitting your email address does
                  not create a fiduciary, advisory, brokerage, planner-client,
                  or any other professional relationship between you and
                  Passed Performance. or any of its founders, employees,
                  contractors, or affiliates.
                </p>
                <p>
                  Passed Performance. is not acting as your investment
                  adviser, broker-dealer, financial planner, attorney,
                  accountant, mental health practitioner, or tax professional.
                  Nothing in this experience should be interpreted as
                  personalized financial guidance.
                </p>
              </>
            ),
          },
          {
            heading: "1.3 Assessment Limitations",
            body: (
              <>
                <p style={{ marginBottom: 16 }}>
                  The topics mentioned in the session are intended only to
                  illustrate common behavioral finance topics and are not a
                  clinical, psychological, neurological, or professional
                  assessment and/or advice of any kind.
                </p>
                <p style={{ marginBottom: 12, color: "var(--pord-text)" }}>
                  User result:
                </p>
                <ul style={ulStyle}>
                  <li>
                    Is not a formal risk tolerance assessment as defined by
                    FINRA, the SEC, or any investment advisory standard.
                  </li>
                  <li>
                    Is not a suitable basis for making any actual investment
                    decision.
                  </li>
                  <li>
                    May not reflect how you would behave in a real market
                    event.
                  </li>
                  <li>
                    Should not be relied upon by any financial adviser,
                    planner, or institution as a formal investor profile.
                  </li>
                  <li>
                    Is intended solely for reflection, education, and product
                    demonstration purposes.
                  </li>
                </ul>
              </>
            ),
          },
          {
            heading: "1.4 Research, Sources & Forward-Looking References",
            body: (
              <>
                <p style={{ marginBottom: 16 }}>
                  References to market-driven actions, cognitive bias
                  research, academic studies, public datasets, surveys, or
                  third-party commentary are included for educational
                  attribution and context only. They are illustrative, not
                  predictive, and do not guarantee any outcome for any
                  individual user.
                </p>
                <p>
                  Passed Performance does not claim affiliation with,
                  endorsement by, sponsorship from, or partnership with any
                  cited institution, publication, academic author, or research
                  source unless explicitly stated.
                </p>
              </>
            ),
          },
          {
            heading: "1.5 Consult a Qualified Professional",
            body: (
              <>
                Before making any investment, tax, legal, retirement, or
                financial planning decision, consult a qualified and
                appropriately licensed professional who can evaluate your
                personal circumstances, goals, risk tolerance, liquidity
                needs, and time horizon.
              </>
            ),
          },
        ]}
      />

      {/* PART 2 - PRIVACY POLICY */}
      <Part
        index="Part 2"
        title="Privacy Policy"
        testid="part-privacy"
        sections={[
          {
            heading: "2.1 Scope & Contact",
            body: (
              <>
                Passed Performance. (&ldquo;Passed Performance.,&rdquo;
                &ldquo;Pord.,&rdquo; &ldquo;Clarity Soundtrack,&rdquo;
                &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is an
                educational investment platform. For privacy-related questions
                or requests, contact:{" "}
                <a
                  href="mailto:info@clarityjournalbyenquips.com"
                  style={{ color: "var(--pord-teal)" }}
                  data-testid="privacy-contact"
                >
                  info@clarityjournalbyenquips.com
                </a>
                .
              </>
            ),
          },
          {
            heading: "2.2 Data Sharing",
            body: (
              <>
                We do not share your information with third parties for
                advertising, lead generation, profiling, or data brokerage. We
                may use service providers for website hosting, form
                processing, or email delivery. If we do, they process your
                data only for those limited purposes and not for their own
                marketing.
              </>
            ),
          },
          {
            heading: "2.3 Data Retention & Deletion",
            body: (
              <>
                We retain waitlist information only as long as reasonably
                necessary. You may request deletion at any time by emailing{" "}
                <a
                  href="mailto:info@clarityjournalbyenquips.com"
                  style={{ color: "var(--pord-teal)" }}
                >
                  info@clarityjournalbyenquips.com
                </a>
                . We will process requests within 7 business days.
              </>
            ),
          },
          {
            heading: "2.4 Children's Privacy",
            body: (
              <>
                Passed Performance is intended for adults 18 and older. We do
                not knowingly collect information from children under 13. If
                you believe a minor has submitted information, contact us and
                we will remove it promptly.
              </>
            ),
          },
          {
            heading: "2.5 Policy Changes",
            body: (
              <>
                We may update this Privacy Policy as the platform evolves.
                Material changes will be communicated via the website and by
                email to waitlist subscribers. The &ldquo;Last Updated&rdquo;
                date above will always reflect the most recent revision.
                Continued use constitutes acceptance of the updated policy.
              </>
            ),
          },
        ]}
      />

      {/* PART 3 - COOKIE POLICY */}
      <Part
        index="Part 3"
        title="Cookie Policy"
        testid="part-cookies"
        sections={[
          {
            heading: "3.1 What we use",
            body: (
              <>
                Pord. uses a minimal set of cookies and local storage entries
                strictly to make the site work and to remember your
                preferences. We do not use third-party advertising,
                cross-site, or profiling cookies.
              </>
            ),
          },
          {
            heading: "3.2 Categories",
            body: (
              <ul style={ulStyle}>
                <li>
                  <strong style={{ color: "var(--pord-text)" }}>
                    Strictly necessary
                  </strong>{" "}
                  — required for page navigation, form submission, and
                  remembering your consent choice on this site.
                </li>
                <li>
                  <strong style={{ color: "var(--pord-text)" }}>
                    Preferences
                  </strong>{" "}
                  — remember filter and reading-state preferences so the
                  reference page feels continuous between visits.
                </li>
                <li>
                  <strong style={{ color: "var(--pord-text)" }}>
                    Analytics (aggregate)
                  </strong>{" "}
                  — anonymous, aggregated counts of page reads to understand
                  what content is useful. Never sold, never tied to your
                  identity.
                </li>
              </ul>
            ),
          },
          {
            heading: "3.3 Your choice",
            body: (
              <>
                You can accept or decline non-essential cookies from the
                consent banner shown on first visit, and change your choice at
                any time by clearing this site&rsquo;s storage in your
                browser. Strictly necessary cookies remain because the site
                cannot function without them.
              </>
            ),
          },
          {
            heading: "3.4 Third-party processors",
            body: (
              <>
                Where we use processors (hosting, form processing, email
                delivery), they receive only the data required to perform
                their function and are contractually limited to that purpose,
                consistent with Section 2.2.
              </>
            ),
          },
        ]}
      />

      {/* PART 4 - TERMS OF SERVICES */}
      <Part
        index="Part 4"
        title="Terms of Services"
        testid="part-terms"
        sections={[
          {
            heading: "1. About Passed Performance.",
            body: (
              <>
                Passed Performance. is an educational investment platform
                operated by EnQUIPs LLC. These Terms apply to the publication,
                and a member/subscriber signup.
              </>
            ),
          },
          {
            heading: "2. Educational Purpose Only",
            body: (
              <>
                Passed Performance. is designed solely for financial
                education. Nothing on this website constitutes investment,
                financial, tax, or legal advice or a recommendation to buy,
                sell, or hold any security or financial instrument. See
                Privacy Policy & Disclaimer for the full educational
                disclaimer.
              </>
            ),
          },
          {
            heading: "3. Eligibility",
            body: (
              <>
                You must be 18 or older to use this website or join the
                waitlist. By submitting your information, you confirm that you
                meet this requirement.
              </>
            ),
          },
          {
            heading: "4. Acceptable Use",
            body: (
              <>
                <p style={{ marginBottom: 12 }}>You agree not to:</p>
                <ul style={ulStyle}>
                  <li>Use this website for any unlawful purpose.</li>
                  <li>
                    Attempt to scrape, reverse-engineer, or interfere with any
                    part of this website.
                  </li>
                  <li>Submit false or misleading information.</li>
                  <li>
                    Represent any Passed Performance. content as personalized
                    financial advice to others.
                  </li>
                </ul>
              </>
            ),
          },
          {
            heading: "5. Intellectual Property",
            body: (
              <>
                All content on this website — including all creative works,
                educational copy, content and framework published, design, and
                audio — is the intellectual property of EnQUIPs LLC. You may
                not reproduce, redistribute, or commercially use any part of
                it without prior written permission.
              </>
            ),
          },
          {
            heading: "6. Disclaimers",
            body: (
              <>
                This website is provided &ldquo;as is&rdquo; without
                warranties of any kind. EnQUIPs does not warrant that the
                site will be uninterrupted or error-free, or that any content
                is accurate, complete, or suitable for your specific
                situation.
              </>
            ),
          },
          {
            heading: "7. Limitation of Liability",
            body: (
              <>
                EnQUIPs LLC shall not be liable for any indirect, incidental,
                or consequential damages arising from your use of this website
                or reliance on its content.
              </>
            ),
          },
          {
            heading: "8. Privacy",
            body: (
              <>
                Your use of this website is governed by the Privacy Policy,
                incorporated here by reference.
              </>
            ),
          },
          {
            heading: "9. Changes",
            body: (
              <>
                We may update these Terms as the platform develops. The
                &ldquo;Last Updated&rdquo; date will reflect the most recent
                revision. Continued use constitutes acceptance.
              </>
            ),
          },
        ]}
      />

      <div className="divider mt-16 mb-10" />
      <Part
        index="Part 5"
        title="Data Use & Internal Caching"
        testid="part-data-use"
        sections={[
          {
            heading: "Permitted Use",
            body: (
              <ul style={ulStyle}>
                <li>Store and cache the data within your own internal systems, databases, research tools, and archives.</li>
                <li>Use the data in your internal models, dashboards, risk tools, and research or investment workflows.</li>
                <li>Retain historical copies of the data for your own internal records, compliance, audit, and research purposes.</li>
              </ul>
            ),
          },
          {
            heading: "Restrictions",
            body: (
              <ul style={ulStyle}>
                <li>You may not sell, license, sublicense, distribute, or otherwise provide Pord data as a standalone product, data feed, or service to any third party.</li>
                <li>You may not make Pord data available to your own clients or any external party in a way that allows them to access, download, or systematically extract the underlying dataset.</li>
                <li>You may not use Pord data to power any external-facing product, service, dashboard, or report whose primary purpose is to expose Pord's dataset (for example, a commercial data feed, public website, or client reporting system that republishes Pord data as-is).</li>
                <li>You may incorporate Pord data into your own internal analyses, reports, and materials (including those you share with clients), provided that such materials do not enable recipients to access or reconstruct Pord's dataset itself.</li>
              </ul>
            ),
          },
          {
            heading: "Post-Termination",
            body: "If your subscription or agreement ends, you must stop accessing and pulling new data from Pord. You may continue to store and use historical data already obtained solely for your internal archive, compliance, audit, and research purposes, subject to all limitations above and without any right to redistribute or commercialize that historical data as a separate product or service.",
          },
        ]}
      />

      <p
        className="label-cap"
        style={{ color: "var(--pord-muted)" }}
        data-testid="terms-contact-line"
      >
        Questions ·{" "}
        <a
          href="mailto:info@clarityjournalbyenquips.com"
          style={{ color: "var(--pord-teal)" }}
        >
          info@clarityjournalbyenquips.com
        </a>
      </p>
    </main>
  );
}

const ulStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

function Part({ index, title, sections, testid }) {
  return (
    <section
      className="fade-in-d1"
      data-testid={testid}
      style={{ marginBottom: 80 }}
    >
      <div className="flex items-baseline gap-5 mb-8">
        <div
          className="eyebrow"
          style={{ color: "var(--pord-sage)", whiteSpace: "nowrap" }}
        >
          {index}
        </div>
        <div
          className="headline"
          style={{
            fontSize: "clamp(26px, 3.4vw, 38px)",
            color: "var(--pord-text)",
          }}
        >
          {title}
        </div>
      </div>

      <div className="divider mb-10" />

      <div style={{ display: "flex", flexDirection: "column", gap: 36 }}>
        {sections.map((s) => (
          <article key={s.heading}>
            <h3
              style={{
                color: "var(--pord-teal)",
                fontSize: 18,
                fontWeight: 400,
                margin: 0,
                marginBottom: 14,
                letterSpacing: "-0.005em",
              }}
            >
              {s.heading}
            </h3>
            <div
              style={{
                color: "var(--pord-muted)",
                fontSize: 16,
                lineHeight: 1.85,
              }}
            >
              {s.body}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
